<template>
  <div class="app-container Srctwo2">
    <div class="left_pad">
      <div class="first_pad" style="height: 38%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">美丽灵峰</span></div>
        <el-carousel height="80%" class="right_pic"
                     v-if="beautifulList.length>0"
                     arrow="never"
                     :autoplay="true"
                     loop
                     :interval="3000"
                     @mouseenter.native="photeword=true"
                     @mouseleave.native="photeword=false"
                     style="position: absolute;top: 4rem;left: 50%;transform: translateX(-50%);height: 80%;"
        >
          <el-carousel-item style="height: 100%;width: 100%;" v-for="(list,index) in beautifulList" :key="index">
            <el-image
              style="width: 100%; height: 100%;"
              :src="baseUrl.replace('/biyi','/file') + list.url.replace('/upload','') + '/' + list.targetFileName"
              :preview-src-list="previewbeautifulList">
              <!-- @mouseover="photeword=true" @mouseout="photeword=false" -->
            </el-image>
            <el-popover
              placement="right-end"
              width="500"
              popper-class="popoverBox"
              trigger="hover">
              <div v-html="list.name"></div>
              <!--              <el-button slot="reference">hover 激活</el-button>-->
              <div class="suipaiword" :class="{show:photeword==true}" v-html="list.name?(list.name):'无'"
                   slot="reference"></div>
            </el-popover>
          </el-carousel-item>
        </el-carousel>
        <div class="no_data" v-if="beautifulList.length==0">
          <img src="../../assets/satistics/icon-no-pic.png" alt="" class="no_data_img">
        </div>
      </div>

      <!--      <info-pad height="38" type="1" title="美丽灵峰">-->
      <!--        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">-->
      <!--       -->
      <!--      </info-pad>-->

      <div class="first_pad" style="height: 45%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">人车监控</span></div>
        <div class="box">
          <div class="info_line" v-if="carData">
            <div class="info_line_item">
              <img src="../../assets/satistics/icon-human.png" alt="" class="item_pic_icon">
              <div class="item_text">
                <div class="item_text1">{{carTotal.peopleTotal}}</div>
                <div class="item_text2">{{selectType==0?"当日":"近七天"}}人流量（次）</div>
              </div>
            </div>
            <div class="info_line_item">
              <img src="../../assets/satistics/icon-car.png" alt="" class="item_pic_icon">
              <div class="item_text">
                <div class="item_text1" style="color: rgba(255, 197, 44, 1)">{{carTotal.carTotal}}</div>
                <div class="item_text2">{{selectType==0?"当日":"近七天"}}车流量（次）</div>
              </div>
            </div>
          </div>
          <ec-line style="height: 68%;" :data="carData" :names="carNames" type="lines" unit="次"
                   v-if="carData"></ec-line>
          <div class="select_type">
            <div :class="[selectType==0?'select_type_item selected':'select_type_item']" @click="changeType(0)">当日</div>
            <div :class="[selectType==1?'select_type_item selected':'select_type_item']" @click="changeType(1)">近七天
            </div>
          </div>
          <div class="no_data" v-if="!carData">
            <img src="../../assets/satistics/icon-no-data.png" alt="" class="no_data_img">
          </div>
        </div>
      </div>

      <div class="third_pad" @click="goThirdPage">
        <img src="../../assets/satistics/icon-lamp.png" alt="" class="third_pad_icon">
        <div class="third_pad_text">智慧路灯应用平台</div>
        <div class="third_pad_link">进入系统</div>
      </div>
    </div>

    <div class="center_pad" style="padding-left: 0.5rem;padding-right: 0.5rem;">
      <info-pad2 height="95" :title="chosenTitle" @change="changeTitle">
        <div class="inner_pad"
             style="position:absolute;z-index: 100;margin-top: 0.6rem;">
          <div class="inner_left" style="display: flex;align-items: center;justify-content: center">
            <img src="../../assets/map/bg3.png" style="width: 100%;height: 100%;position:absolute;z-index: 1"/>
            <ScreenMap
              ref="mapBox"
              :videoids="videoids"
              @handleView="handleView"
              style="position:absolute;z-index: 2;width: 94%;height: 94%;"
            />
          </div>
          <img src="../../assets/map/topBg.png" style="width: 100%;position:absolute;z-index: 3;top: -1.5rem;"/>
          <img src="../../assets/map/leftBg.png"
               style="height: 100%;position:absolute;z-index: 3;left:-1.5rem;top: 0;"/>
          <img src="../../assets/map/topBg.png" style="width: 100%;position:absolute;z-index: 3;bottom: -1.5rem;"/>
          <img src="../../assets/map/leftBg.png"
               style="height: 100%;position:absolute;z-index: 3;right:-1.5rem;top: 0;"/>
          <!--          <div class="videodingwei" v-show="innerPic==1">-->
          <!--            <div class="videodw" v-for="(item ,index ) in videoids" :class="`dw`+index"-->
          <!--                 @click="handleView(item)"></div>-->
          <!--          </div>-->
        </div>

        <div class="monitor_pad" v-if="showMonitor">
          <div class="monitor_title">
            <span class="monitor_title_text">视频监控</span>
            <i class="el-icon-close" @click="closeCamera"></i>
          </div>
          <div class="monitor_content">
            <div class="monitor_item">
              <Video
                id="myVideo1"
                class="video-js video_pad monitor_item_img"
                v-if="monitorUrl.length>0"
                :autoplay="true"
              >
              </Video>
            </div>
            <div class="monitor_item">
              <Video
                id="myVideo2"
                class="video-js video_pad monitor_item_img"
                v-if="monitorUrl.length>0"
                :autoplay="true"
              >
              </Video>
            </div>
            <div class="monitor_item">
              <Video
                id="myVideo3"
                class="video-js video_pad monitor_item_img"
                v-if="monitorUrl.length>0"
                :autoplay="true"
              ></Video>
            </div>
          </div>
        </div>
      </info-pad2>
    </div>

    <div class="right_pad">
      <div class="first_pad" style="height: 37%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">随手拍</span></div>
        <el-carousel height="80%" class="right_pic"
                     v-if="photeList.length>0"
                     arrow="never"
                     :autoplay="true"
                     loop
                     :interval="3000"
                     @mouseenter.native="photeword2=true"
                     @mouseleave.native="photeword2=false"
                     style="position: absolute;top: 4rem;left: 50%;transform: translateX(-50%);height: 80%;"
        >
          <el-carousel-item style="height: 100%;width: 100%;" v-for="(list,index2) in photeList" :key="index2">
            <div class="suipaiword" :class="{show:photeword2==true}">{{list.name}}</div>
            <el-image
              style="width: 100%; height: 100%;"
              :src="baseUrl.replace('/biyi','/file') + list.url.replace('/upload','') + '/' + list.targetFileName"
              :preview-src-list="previewList">
            </el-image>
            <!-- <img style="height: 100%;width: 100%;" :src="baseUrl.replace('/biyi','/file') + list.url.replace('/upload','') + '/' + list.targetFileName" alt=""  @mouseover="photeword=true" @mouseout="photeword=false"> -->
          </el-carousel-item>
        </el-carousel>
        <!-- <div class="more_button">更多</div> -->
        <div class="no_data" v-if="photeList.length==0">
          <img src="../../assets/satistics/icon-no-pic.png" alt="" class="no_data_img">
        </div>
      </div>

      <div class="first_pad" style="height: 24%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">工单列表</span></div>
        <div class="box2">
          <div style="width: 100%;height: 100%; z-index: 1000;" v-if="orderList.length>0">
            <info-list :data='orderList' type="生态人居"></info-list>
          </div>

          <div class="select_year">
            <el-select v-model="selectedMonth"
                       class="xalachoose"
                       :popper-append-to-body="false"
                       @change="getOrderList"
            >
              <el-option v-for="(item,index) in monthSelections"
                         :key="index"
                         :value="item"
                         :label="item"
              ></el-option>
            </el-select>
          </div>
          <div class="no_data" v-if="orderList.length==0">
            <img src="../../assets/satistics/icon-no-order.png" alt="" class="no_data_img">
          </div>
        </div>
      </div>

      <div class="first_pad" style="height: 31%;z-index: 500">
        <img src="../../assets/satistics/img-content-back.png" alt="" class="back_img">
        <div class="pad_title"><span
          class="pad_title_text selected_title">工单统计分析</span></div>
        <div class="box2">
          <ec-pie2 style="background: rgba(35, 55, 91, 0.45)" type="细环" v-if="pieData.length>0" :data="pieData"></ec-pie2>
          <div class="no_data" v-else>
            <img src="../../assets/satistics/icon-no-data.png" alt="" class="no_data_img">
          </div>
        </div>
      </div>

    </div>

    <video-modal ref="videoModal"></video-modal>
  </div>
</template>

<script>
  import {Select, Option, Carousel, CarouselItem, Popover} from 'element-ui'
  import Vue from 'vue'
  import VideoJs from "video.js";
  import util from '@/libs/util.js';
  import ScreenMap from "@/components/map/screenMap"

  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Carousel)
  Vue.use(CarouselItem)
  Vue.use(Popover)

  export default {
    name: "enviroment",
    data() {
      return {
        videoids: [],
        baseUrl: util.baseUrl,
        selectType: 0,
        innerPic: 0,
        pieData: [],
        // pieData: false,
        discribe: '在发展经济的同时，灵峰村大力发展社会事业，新建了社区医疗卫生服务站、幼儿园、600吨级生活污水处理厂等，实现了刚性化路面、太自来水、有线电视和路灯四个“村村通”。同时，实行了“两免三补贴”，即九年制义务教育免费、自来水定量免费，大病医疗保险补贴、农保补贴和药费差价补贴。根据社会主义新农村建设需要，灵峰村扎实推进村庄环境整治工作，先后完成了葛家浜、毛家桥等自然村的整治改造，启动了居民集中居住点建设，以社区服务中心为核心的灵峰公园等一批便民设施也即将投入使用。',
        selectedMonth: '',
        monthSelections: ['2022.06', '2022.07'],
        monitorId: [],
        monitorUrl: [],
        showMonitor: false,
        orderList: [],
        ordertablist: [],
        chosenTitle: ['智慧路灯', '摄像监控'],
        picList: true,
        photeword: false,
        photeword2: false,
        beautifulList: [
          {url: require('../../assets/satistics/img-4.jpg'), name: "某摄"},
        ],
        photeList: [
          {url: require('../../assets/satistics/img-4.jpg'), name: "某摄"},
        ],
        carData: [
          {
            name: '车流量',
            type: 'line',
            // stack: 'Total',
            data: [5, 1, 15, 53, 81, 92, 162, 148, 146, 169, 174, 29, 123, 180, 37, 69, 148, 186, 140, 146, 188, 76, 38, 11]
          },
          {
            name: '人流量',
            type: 'line',
            // stack: 'Total',
            data: [29, 5, 79, 266, 405, 460, 614, 441, 531, 647, 770, 347, 616, 703, 587, 349, 542, 834, 702, 731, 943, 384, 191, 59]
          }],
        carNames: ['1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时', '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时', '24时'],
        carTotal: {
          peopleTotal: 0,
          carTotal: 0,
        },

        equipInfo: {
          light: 0,
          led: 0,
          sensor: 0,
          audio: 0,
          pole: 0,
          camera: 0
        },
        monitorVideo1: null,
        monitorVideo2: null,
        monitorVideo3: null,
        monitorVideo4: null,
        monitorVideo5: null,
        monitorVideo6: null,
        monitorIntervalId: null,
        cartimer: null,
      }
    },
    components: {
      infoPad: () => import('./components/infoPad'),
      infoPad2: () => import('./components/infoPadNoTitle'),
      ecLine: () => import('./components/ec-line'),
      ecPie: () => import('./components/ec-pie'),
      ecPie2: () => import('./components/ec-pieNoNum'),
      infoList: () => import('./components/infolist'),
      videoModal: () => import('./components/videokz.vue'),
      ScreenMap,
    },
    created() {
      let today = new Date()
      this.selectedMonth = this.dayjs().format("YYYY-MM");
      this.getBeautiful()
      this.getMonthSelection(today)
      this.getOrderList()
      this.getEquipAmount()
      this.getEventManager()
      this.changeType(0)
    },
    mounted() {
      // this.hkDevice('928fd990b1e3483f8847d8f9d1cf7996')
      // this.hkDevice('d1fd53ba6278495f8ecd77a25530a87a')
      Promise.all([
        this.hkDevice('928fd990b1e3483f8847d8f9d1cf7996'),
        this.hkDevice('d1fd53ba6278495f8ecd77a25530a87a'),
      ])
    },
    beforeDestroy() {
      this.monitorUrl = []
      clearInterval(this.monitorIntervalId)
      clearInterval(this.cartimer)
      this.monitorIntervalId = null
      this.monitorVideo1.dispose()
      this.monitorVideo2.dispose()
      this.monitorVideo3.dispose()
    },
    computed: {
      previewList() {
        return this.photeList.map(item => this.baseUrl.replace('/biyi', '/file') + item.url.replace('/upload', '') + '/' + item.targetFileName);
      },
      previewbeautifulList() {
        return this.beautifulList.map(item => this.baseUrl.replace('/biyi', '/file') + item.url.replace('/upload', '') + '/' + item.targetFileName);
      },
    },
    methods: {
      initMonitorVideoController(minitorName, url) {
        minitorName.src([
          {
            type: "application/x-mpegURL",
            src: url,
          },
        ]);
      },
      changeType(index) {
        this.selectType = index
        let nowTime = this.dayjs().format();
        let nowday = this.dayjs().format("YYYY-MM-DD");
        let choonse0 = {
          startTime: this.dayjs(this.nowTime).subtract(1, 'day').format('YYYY-MM-DD'),
          endTime: this.dayjs(this.nowTime).subtract(1, 'day').format('YYYY-MM-DD'),
        }
        let choonse1 = {
          startTime: this.dayjs(this.nowTime).subtract(7, 'day').format('YYYY-MM-DD'),
          endTime: this.dayjs(this.nowTime).subtract(1, 'day').format('YYYY-MM-DD'),
        }
        this.nowday = this.dayjs().format("YYYY-MM-DD");
        this.firstday = this.dayjs(this.nowTime).startOf('month').format('YYYY-MM-DD');
        this.lastmontday = this.dayjs(this.nowTime).endOf('month').format("YYYY-MM-DD");

        this.jinSanShiDay = this.dayjs(this.nowTime).subtract(29, 'day').format('YYYY-MM-DD');
        if (index == 0) {
          // this.carData = [
          //   {
          //     name: '车流量',
          //     type: 'line',
          //     stack: 'Total',
          //     data: [5, 1, 15, 53, 81, 92, 162, 148, 146, 169, 174, 29, 123, 180, 37, 69, 148, 186, 140, 146, 188, 76, 38, 11]
          //   },
          //   {
          //     name: '人流量',
          //     type: 'line',
          //     stack: 'Total',
          //     data: [29, 5, 79, 266, 405, 460, 814, 741, 731, 847, 870, 147, 616, 903, 187, 349, 742, 934, 702, 731, 943, 384, 191, 59]
          //   }
          // ]
          // this.carNames = ['1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时', '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时', '24时']
          this.getYesterdayFlow()
          this.getCarTotal(choonse0)
        } else {
          // this.carNames = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          // this.carData = [
          //   {
          //     name: '车流量',
          //     type: 'line',
          //     stack: 'Total',
          //     data: [120, 132, 101, 134, 90, 230, 210]
          //   },
          //   {
          //     name: '人流量',
          //     type: 'line',
          //     stack: 'Total',
          //     data: [220, 182, 191, 234, 290, 330, 310]
          //   }]
          this.getSevenFlow()
          this.getCarTotal(choonse1)

        }
      },
      changeTitle(index) {
        this.innerPic = index
        this.getEquipAmount()
      },

      getMonitorIds(id) {
        this.$http.get(`api/hkDevice/page?&regionId=${id}&currentPage=1&pageSize=100`).then(res => {
          let list = res.data.data.list
          list.forEach(item => {
            this.monitorId.push(item.deviceId)
            this.getMonitorUrl(item.deviceId)
          })
        })
      },

      closeCamera() {
        this.showMonitor = false
        this.initMonitorVideoController(this.monitorVideo1, null);
        this.initMonitorVideoController(this.monitorVideo2, null);
        this.initMonitorVideoController(this.monitorVideo3, null);
        // this.monitorVideo1.dispose()
        // this.monitorVideo2.dispose()
        // this.monitorVideo3.dispose()

        // let monitorItem = document.querySelectorAll('.monitor_item')
        // console.log(monitorItem, 'test')
        // monitorItem.forEach((item, index) => {
        //   item.innerHTML = `<Video id="myVideo${index + 1}" class="video-js vjs-default-skin  vjs-big-play-centered monitor_item_img" v-if="monitorUrl.length>${index}" :autoplay="true" preload="auto" style="width: 100%;height: 100%" controlBar="true"><source src="${this.monitorUrl[index]}" style="width: 100%;height: 100%" type="application/x-mpegURL"></video>`
        // })
      },
      openCamera() {
        this.showMonitor = true
        setTimeout(() => {
          // console.log(document.querySelector("#myVideo1"), 'test')
          this.monitorVideo1 = VideoJs("myVideo1");
          this.monitorVideo2 = VideoJs("myVideo2");
          this.monitorVideo3 = VideoJs("myVideo3");
          this.initMonitorVideoController(this.monitorVideo1, this.monitorUrl[0]);
          this.initMonitorVideoController(this.monitorVideo2, this.monitorUrl[1]);
          this.initMonitorVideoController(this.monitorVideo3, this.monitorUrl[2]);
          this.monitorVideo1.load()
          this.monitorVideo2.load()
          this.monitorVideo3.load()
        }, 200)
      },

      getEquipAmount() {
        this.$http.post('api/lamp/get', {
          map: {
            code: 'getEquipCount'
          },
          requestMethod: "s/tpd/s/ajax"
        }).then(res => {
          let data = JSON.parse(JSON.stringify(res.data.data.data))
          this.equipInfo = data
        })
      },

      getMonitorUrl(id) {
        this.$http
          .post("/api/hkDevice/requestHk", {
            url: "/api/video/v1/cameras/previewURLs",
            jsonObject: {
              cameraIndexCode: id,
              protocol: "hls",
              streamType: 1
            },
          }).then(res => {
          let url = res.data.data.url
          if (process.env.NODE_ENV != 'development') {
            url = "https://lfczhxc.com/hk/" + res.data.data.url.substring(25);
          }
          this.monitorUrl.push(url)
          // console.log(this.monitorUrl[0])
        })
      },

      goThirdPage() {
        // window.open('http://mind.suzhoulamp.cn/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/')
        // window.open('https://city.suzhoulamp.cn/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/index.new.jsp?wid=213')
        window.open('http://47.96.126.134:8088/s/scd/login?id=3757&tpdcode=FU6YUFU86RLKYVHH&url=/index.new.jsp?wid=213')

      },
      // 添加日期选择
      getMonthSelection(today) {
        let tmpSelect = []
        let year = today.getFullYear()
        let month = today.getMonth()

        for (let i = 0; i < 6; i++) {
          let month1 = (month + 1) > 9 ? (month + 1) : '0' + (month + 1)
          tmpSelect.push(year + '-' + month1)
          if (month > 0) {
            month -= 1
          } else {
            month = 11
            year -= 1
          }

        }
        this.monthSelections = tmpSelect
      },
      //工单列表
      getOrderList() {
        // 1 矛盾调解业务工单 2随手拍业务工单 0-1一键告警 0-2烟感 0-3燃气 0-4摄像头 0-4-1火点监测告警工单 0-4-2漂浮物监测告警工单 0-4-3不文明行为监测告警工单
        let gdtype = ['1', '2', '0-1', '0-3', '0-4', '0-4-1', '0-4-2', '0-4-2', '0-4-3']
        let gdtypecolor = ["#3467E7", "#0AAAAF", "#D8393B", "#52C41A", "#DB499E", "#886BA5", "#F18241", "#2DA6EA", "#9518E4"]
        //生态人居：1 矛盾调解业务工单 2随手拍业务工单 0-1一键告警 0-4-3不文明行为监测告警工单
        let jsondata = {
          queryMonthTime: this.selectedMonth,
          typeList: ['1', '2', '0-1', '0-4-3']
        }
        this.$http.post("api/threeScreen/evn/pageWorkOrder", jsondata).then((res) => {
          // console.log(res)
          if (res.data.code == 200) {
            // this.orderList = res.data.list
            let data = res.data.data.list
            let listArr = []
            let tmpArr = []
            let indexcolor = -1
            data.forEach((item, index) => {
              let items1 = item
              let index1 = gdtype.findIndex(info => info === item.type);
              items1["ordercolorindex"] = gdtypecolor[index1]
              tmpArr.push(items1)
              if (index == data.length - 1 || index % 2 == 1) {
                listArr.push(tmpArr)
                tmpArr = []
              }
            })
            this.orderList = JSON.parse(JSON.stringify(listArr))
          }

        });
        this.getPieChart(jsondata)
      },
      //工单统计分析
      getPieChart(jsondata) {
        let tempArr = []
        this.$http.post("api/threeScreen/evn/workOrderParse", jsondata).then((res) => {
          // console.log('getPieChart',res)
          if (res.data.code == 200) {
            res.data.data.forEach(item => {
              let obj = {
                name: item.key,
                value: item.value
              }

              tempArr.push(obj)
            })

            // this.pieData = tempArr
            // 生态人居工单数据统计：随手拍工单127，矛盾调解44，其他26
            this.pieData = [
              {name: '随手拍工单', value: 127},
              {name: '矛盾调解', value: 44},
              {name: '其他', value: 26},
            ]
          }
        });
      },
      // 随手拍
      getEventManager() {
        this.$http.get('api/emScren/getEventManager').then(res => {
          if (res.data.code == 200) {
            let photearr = []
            res.data.data.forEach(item => {
              item.appendixList.forEach(info => {
                let obj = {
                  url: info.url,
                  name: item.eventContent,
                  targetFileName: info.targetFileName
                }

                photearr.push(obj)
              })
            })
            this.photeList = photearr
          }
        })
      },
      // 美丽凌峰
      getBeautiful() {
        this.$http.get('api/emScren/getArticleInfo').then(res => {
          if (res.data.code == 200) {
            let photearr = []
            res.data.data.forEach(item => {
              // console.log(item, 22222222222);
              item.appendixList.forEach(info => {
                let obj = {
                  url: info.url,
                  name: item.content,
                  targetFileName: info.targetFileName,
                  content: item.content,
                }

                photearr.push(obj)
              })
            })
            this.beautifulList = photearr
          }
        })
      },
      // 人车监控图(昨日)
      getYesterdayFlow() {
        this.$http.get(`/api/threeScreen/hk/yesterdayFlow`).then(res => {
          let cardata = [
            {
              name: '车流量',
              type: 'line',
              // stack: 'Total',
              // smooth: true,
              data: []
            },
            {
              name: '人流量',
              type: 'line',
              // smooth: true,
              // stack: 'Total',
              data: []
            }
          ]
          let carnames = []
          if (res.data.code == 200) {
            let title = res.data.data.title
            let i = 0
            title.forEach(item => {
              carnames.push(item + "时")
              i += 50;
              cardata[0].data.push(res.data.data.car[item])
              cardata[1].data.push(res.data.data.people[item])
            })

            this.carData = JSON.parse(JSON.stringify(cardata))
            this.carNames = JSON.parse(JSON.stringify(carnames))
            // console.log(this.carData)
          }
        })
      },

      // 二十四、人车监控图(7日)
      getSevenFlow() {
        this.$http.get(`/api/threeScreen/hk/sevenFlow`).then(res => {
          let cardata = [
            {
              name: '车流量',
              type: 'line',
              data: []
            },
            {
              name: '人流量',
              type: 'line',
              data: []
            }
          ]
          let carnames = []
          if (res.data.code == 200) {
            let title = res.data.data.title
            title.forEach(item => {
              carnames.push(item)
              cardata[0].data.push(res.data.data.car[item])
              cardata[1].data.push(res.data.data.people[item])
            })

            this.carData = cardata
            this.carNames = carnames
          }
        })
      },
      //人车监控总数统计
      getCarTotal(choonse) {
        // 人流量总数
        this.$http.get(`/api/threeScreen/hk/peopleFlow`, {params: choonse}).then(res => {
          if (res.data.code == 200) {
            this.carTotal.peopleTotal = 0
            this.plusNum("peopleTotal", res.data.data.count, this.calcStep(res.data.data.count));
            // this.carTotal.peopleTotal= res.data.data.count
          }
        })
        //车流量总数
        this.$http.get(`/api/threeScreen/hk/carFlow`, {params: choonse}).then(res => {
          if (res.data.code == 200) {
            this.carTotal.carTotal = 0
            this.plusNum("carTotal", res.data.data.count, this.calcStep(res.data.data.count));
            // this.carTotal.carTotal= res.data.data.count
          }
        })
      },

      /**
       * @description 数字滚动递增
       * @param {String} key - 对象key
       * @param {Number} value - 递增结果值
       * @param {Number} step - 递增步伐
       */
      plusNum(key, value, step) {
        var that = this;
        setTimeout(() => {
          if (parseInt(that.carTotal[key]) < parseInt(value)) {
            var data = that.carTotal[key] + step;
            if (data <= value) {
              that.carTotal[key] = data;
            } else {
              that.carTotal[key] = value;
            }
            that.plusNum(key, value, step);
          } else {
            return;
          }
        }, 100)
      },
      /**
       * @description 计算递增步伐
       */
      calcStep(num) {
        return Math.ceil(num / 20);
      },
      hkDevice(id) {
        this.$http.get('api/hkDevice/page?deviceName=&regionId=' + id + '&currentPage=1&pageSize=10').then(res => {
          if (res.data.code == 200) {
            res.data.data.list.forEach(item => {
              this.videoids.push(item)
            })
          }
        })
      },
      handleView(row) {
        this.$refs.videoModal.modal = true;
        this.$refs.videoModal.getData(row);
      },
    }
  }
</script>
<style>
  .popoverBox {
    background: rgba(28, 56, 107, 0.85) !important;
    max-height: 30% !important;
    overflow-y: auto !important;
    color: #fff !important;
    border: 1px solid #142D65 !important;
    box-shadow: 2px 2px 8px 2px #767b87;
  }

  /*滚动条样式*/
  .popoverBox::-webkit-scrollbar {
    width: 3px;
  }

  .popoverBox::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 3px rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.3);
  }

  .popoverBox::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px rgba(255, 255, 255, 0.3);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

</style>
<style scoped lang="less">

  .first_pad {
    position: relative;
    width: 100%;
    margin: 1.8rem 0;

    .pad_title {
      position: absolute;
      left: 5%;
      top: 5%;
      font-size: 20px;
      color: rgba(73, 169, 255, 1);
      user-select: none;

      .pad_title_text {
        margin: 0 0.8rem;
        cursor: pointer;
      }

      .selected_title {
        font-size: 26px;
        color: #FFFFFF;
        font-family: myTitle;
      }
    }

    .content_area {
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translate(-50%, 0);
      width: 90%;
      height: 80%;


    }

    .top_right {
      position: absolute;
      right: 5%;
      top: 6%;
    }

    .more_button {
      font-size: 14px;
      color: rgba(0, 247, 255, 1);
      user-select: none;
      cursor: pointer;
    }


    .back_img {
      width: 100%;
      height: 100%;
    }

    .circle_img {
      position: absolute;
      left: 15.5%;
      top: 55%;
      transform: translate(0, -50%);
      width: 40%;
    }

    .gd_list_item {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      margin: 0.6rem 0.4rem;
      padding: 0.8rem 0.5rem 0.3rem 0.5rem;
      background: rgba(4, 49, 110, 0.4);
      box-sizing: border-box;
      cursor: pointer;

      .gd_list_item_line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        box-sizing: border-box;

        .gd_list_item_type {
          width: 60%;
          // padding: 4px;
          color: #ffffff;
          // text-align: center;
          span {
            background: rgba(50, 101, 225, 0.5);
            border-radius: 5px;
            color: #ffffff;
            padding: 0.2rem 0.4rem;
          }

          // border: 1px solid rgba(49, 206, 255, 1);
          // color: rgba(49, 206, 255, 1);
        }

        .gd_list_item_time {
          color: #ffffff;
          text-align: right;
        }
      }

      .gd_list_item_content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;

        .gd_list_item_title {
          // width:100%;
          text-align: left;
          color: white;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 3;
          // -webkit-box-orient: vertical;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }

        .gd_list_item_status {
          font-size: 14px;
          width: 60px;
          text-align: right;
        }
      }
    }
  }

  .box {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    height: 80%;
    width: 88%;
  }

  .box2 {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    height: 68%;
    width: 88%;
  }

  .app-container {
    width: 100%;
    height: 100%;
    position: relative;

    .left_pad {
      position: absolute;
      top: 7%;
      left: 0;
      height: 93%;
      width: 30%;
      padding: 1.2rem 1rem;

      .right_pic {
        width: 85%;
        height: 100%;
        overflow: hidden;

        ::v-deep {
          .el-carousel__item {
            height: 100%;
          }

          .el-carousel__indicators {
            bottom: 1.1rem;
          }
        }
      }


      .card_pad {
        width: 100%;
        height: 100%;

        .card_img {
          width: 100%;
          height: 100%;

          .card_img_icon {
            height: 100%;
            width: 100%;
          }
        }

        .card_text {
          background: rgba(0, 25, 61, 0.65);
          padding: 0.4rem 1rem;
          font-size: 14px;
          font-weight: 400;
          color: #D5E6FF;
          line-height: 20px;

          span {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .third_pad {
        height: 9%;
        margin: 0 1.5rem;
        position: relative;
        background: rgba(22, 40, 72, 0.2);
        display: flex;
        align-items: center;
        padding: 0.2rem 1.5rem;
        cursor: pointer;
        z-index: 500;

        .third_pad_icon {
          width: 14%;
        }

        .third_pad_text {
          padding: 0.8rem;
          flex: 1;
          font-size: 20px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 28px;
        }

        .third_pad_link {
          font-size: 20px;
          font-weight: 400;
          color: #46C4FF;
          line-height: 28px;
        }
      }

      .info_line {
        position: relative;
        height: 25%;
        margin: 0 0 0.5rem 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .info_line_item {
          width: 49%;
          height: 100%;
          background: rgba(22, 40, 72, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.8rem;

          .item_pic_icon {
            width: 50px;
            height: 60px;
            margin-right: 1.5rem;
          }

          .item_text {
            color: #fff;
            width: 100%;

            .item_text1 {
              font-family: myDigib;
              font-size: 38px;
              font-weight: bold;
              line-height: 45px;
            }

            .item_text2 {
              font-size: 16px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 22px;
            }
          }
        }
      }

      .select_type {
        position: absolute;
        top: calc(-0.4rem - 48px);
        right: 0.6rem;
        width: 25%;
        height: 44px;
        display: flex;
        align-items: center;
        color: #fff;

        .select_type_item {
          flex: 1;
          height: 100%;
          font-size: 16px;
          line-height: 44px;
          text-align: center;
          cursor: pointer;
        }

        .selected {
          background: linear-gradient(to bottom, rgba(48, 101, 201, 0) 0%, rgba(48, 101, 201, 0.7100) 100%);
          border-width: 0 0 3px 0;
          border-style: solid;
          border-color: rgba(0, 174, 255, 1);
        }
      }
    }

    .center_pad {
      position: absolute;
      left: 30%;
      top: 9%;
      padding: 0 1.5rem 2rem 1rem;
      height: 91%;
      width: 40%;

      .inner_pad {
        position: relative;
        width: 100%;
        height: 100%;

        .inner_left_top {
          position: absolute;
          left: 0;
          top: 0;

          .inner_line1 {
            background: rgba(29, 76, 153, 0.2);
            display: flex;
            align-items: center;
            color: #fff;
            padding: 0 1.4rem;
            height: 6.5rem;
            margin-bottom: 1rem;
            position: relative;

            .inner_line1_icon {
              width: 40%;

              .line1_icon_img {
                width: 80%;
              }
            }

            .inner_line1_text {
              font-size: 16px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 22px;
            }

            .inner_line1_num {
              font-family: myDigib;
              font-size: 42px;
              font-weight: bold;
              color: #FFFFFF;
              line-height: 42px;
            }
          }


        }

        .inner_right_top {
          position: absolute;
          right: 0;
          top: 0;

          .inner_line2 {
            width: 100%;
            height: calc(100% - 7.5rem);

            .inner_line2_content {
              height: 210px;
              position: relative;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .inner_line2_item {
                background: rgba(29, 76, 153, 0.2);
                /*border: 2px solid #0E223D;*/
                display: flex;
                align-items: center;
                padding: 0.4rem 0.8rem;
                color: #fff;

                .inner_line2_item_icon {
                  width: 16%;

                  .item_icon_img {
                    width: 100%;
                  }
                }

                .inner_line2_item_text {
                  flex: 1;
                  padding: 0 0.3rem;
                  font-size: 16px;
                }

                .inner_line2_item_num {
                  padding: 0 0.5rem;
                  font-family: myDigib;
                  font-size: 32px;
                  font-weight: 600;
                }

                .more_img {
                  width: 14px;
                }
              }
            }
          }

        }
      }

      .monitor_pad {
        position: absolute;
        bottom: 0;
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        .monitor_title {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: white;
          padding: 6px 18px;
          background: linear-gradient(90deg, #102B67 0%, #021F5E 100%);
          /*45*/

          .monitor_title_text {
            font-size: 22px;
            font-family: myTitle;
            font-weight: 500;
          }

          i {
            font-size: 24px;
            cursor: pointer;
          }
        }

        .monitor_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.8rem 0.6rem;
          background: rgba(32, 91, 189, 0.35);

          .monitor_item {
            width: 33%;
            height: 160px;

            .monitor_item_img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .inner_left {
        height: 100%;
        width: 100%;
        /*background: green;*/

        .inner_left_icon {
          width: 100%;
          height: 100%;
        }
      }

      .more_button {
        color: rgba(70, 196, 255, 1);
        position: absolute;
        top: -40px;
        right: 0.4rem;
        cursor: pointer;
      }

      .table_title_array {
        display: none !important;
      }
    }

    .right_pad {
      position: absolute;
      top: 7%;
      right: 0;
      height: 93%;
      width: 30%;
      padding: 1.2rem 1rem;
      z-index: 501;

      .more_button {
        color: rgba(70, 196, 255, 1);
        position: absolute;
        top: -40px;
        right: 0.4rem;
        cursor: pointer;
      }

      .right_pic {
        width: 85%;
        height: 100%;
        overflow: hidden;


        ::v-deep {
          .el-carousel__item {
            height: 100%;
          }

          .el-carousel__indicators {
            bottom: 1.1rem;
          }
        }
      }

      .more_button {
        color: rgba(70, 196, 255, 1);
        cursor: pointer;
      }

      .select_year {
        position: absolute;
        top: -3rem;
        right: 0.5rem;


        .month_picker {
          cursor: pointer;

          ::v-deep {

            .el-input__suffix {
              display: flex;
              align-items: center;
            }

            .el-input__prefix {
              display: none;
            }

            .el-input__inner {
              background: rgba(9, 59, 143, 1);
              border-color: rgba(25, 77, 164, 1);
              width: 7rem;
              cursor: pointer;
              padding: 4px 12px;
              border-radius: 2px;

              height: 32px;
              color: #fff;
            }
          }

        }
      }

      .list_item:nth-child(odd) {
        background: rgba(4, 49, 110, 0.65)
      }

      .list_item:nth-child(even) {
        background: rgba(7, 22, 41, 0.65)
      }

      .list_item {
        width: 100%;
        height: 20%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .list_item_type {
          text-align: center;
          width: 24%;
          padding: 0 0.5rem;
          border: 1px solid;
        }

        .list_item_title {
          width: 65%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .list_item_status {
          width: 10%;
        }
      }

    }

    .arrow_border_pad {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat;
      background-size: 10px 10px;
    }

    .no_data {
      position: relative;
      width: 100%;
      height: 100%;
      background: rgba(35, 55, 91, 0.4500);

      .no_data_img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 42%;
      }
    }
  }

  .suipaiword {
    position: absolute;
    z-index: 100;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    color: #FFFFFF;
    width: 100%;
    display: none;
    // max-height: calc(50%);
    &.show {
      width: 100%;
      display: block;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* 指定行数*/
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .xalachoose {
    background: rgba(59, 92, 147, 1);
    margin-right: 0.8rem;
  }

  .videodingwei {
    width: 80%;
    position: absolute;
    top: 18%;
    display: flex;
    // justify-content: space-around;
    margin-left: 10%;

    .videodw {
      width: 2.25rem;
      height: 2.5625rem;
      background: url(../../assets/satistics/img-enviromentdian.png);
      background-size: 100% 100%;
      cursor: pointer;

      &.dw0 {
        margin: 11rem 0 0 0rem;
      }

      &.dw1 {
        margin: 3rem 0 0 1.3rem;
      }

      &.dw2 {
        margin: 5rem 0 0 3.8rem;
      }

      &.dw3 {
        margin: 0rem 0 0 1.8rem;
      }

      &.dw4 {
        margin: 6rem 0 0 1.5rem;
      }

      &.dw5 {
        margin: 2rem 0 0 0rem;
      }

      &.dw6 {
        margin: 6rem 0 0 5rem;
      }

      &.dw7 {
        margin: 8rem 0 0 2rem;
      }

      &.dw8 {
        margin: 11rem 0 0 2rem;
      }
    }

    // .videodw2{
    // 	width: 3.125rem;
    // 	height: 6rem;
    // 	border: 1px solid #fff;
    // 	margin: 3rem 0 0 4rem;

    // }
  }

  /deep/ .el-input__inner {
    // background: none !important;
    // color: #00FDFF;
    // width: 8.8rem;
    // height: 1.8rem;
    // line-height: 1.8rem;
    // border: 1px solid #587CA0;
    background: #0E235D !important;
    color: #2ECDFF;
    width: 8.3rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border: 1px solid #587CA0;
  }

  /deep/ .el-input__icon {
    line-height: 1.8rem;
  }

  /deep/ .el-select-dropdown {
    background: rgba(40, 82, 163, 0.7);
    border: 1px solid #1060A8;
    z-index: 200;
  }

  /deep/ .el-input__prefix, /deep/ .el-input__suffix {
    color: #587CA0;
  }

  /*// select选择器*/
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(20, 44, 82, 0.8);
  }

  /deep/ .el-popper[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: rgba(40, 82, 163, 0.7);
  }

  /deep/ .el-select-dropdown__item.selected {
    // color: #00FDFF;
    color: #2ECDFF;

  }

  .el-select-dropdown__item {
    color: #FFFFFF;
  }
</style>

